import { render } from "./stopPhone.vue?vue&type=template&id=49b10bdf&scoped=true"
import script from "./stopPhone.vue?vue&type=script&lang=js"
export * from "./stopPhone.vue?vue&type=script&lang=js"

import "./stopPhone.vue?vue&type=style&index=0&id=49b10bdf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49b10bdf"

export default script